/**
 * 路由配置
 */

import { createRouter, createWebHistory } from 'vue-router'
import Layout from '../components/Layout.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { title: '数据总览', icon: 'DataAnalysis' }
      },
      {
        path: 'apps',
        name: 'Apps',
        component: () => import('../views/Apps.vue'),
        meta: { title: 'App管理', icon: 'App' }
      },
      {
        path: 'groups',
        name: 'Groups',
        component: () => import('../views/Groups.vue'),
        meta: { title: '群组管理', icon: 'ChatLineRound' }
      },
      {
        path: 'industries',
        name: 'Industries',
        component: () => import('../views/Industries.vue'),
        meta: { title: '行业配置', icon: 'OfficeBuilding' }
      },
      {
        path: 'provinces',
        name: 'Provinces',
        component: () => import('../views/Provinces.vue'),
        meta: { title: '省份配置', icon: 'Location' }
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('../views/Users.vue'),
        meta: { title: '用户查看', icon: 'User' }
      },
      {
        path: 'messages',
        name: 'Messages',
        component: () => import('../views/Messages.vue'),
        meta: { title: '消息查看', icon: 'Message' }
      },
      {
        path: 'system-notifications',
        name: 'SystemNotifications',
        component: () => import('../views/SystemNotifications.vue'),
        meta: { title: '系统通知', icon: 'Bell' }
      },
      {
        path: 'reports',
        name: 'Reports',
        component: () => import('../views/Reports.vue'),
        meta: { title: '举报管理', icon: 'Warning' }
      },
      {
        path: 'media-checks',
        name: 'MediaChecks',
        component: () => import('../views/MediaChecks.vue'),
        meta: { title: '内容风控', icon: 'Warning' }
      },
      {
        path: 'websocket-monitor',
        name: 'WebSocketMonitor',
        component: () => import('../views/WebSocketMonitor.vue'),
        meta: { title: 'WebSocket监控', icon: 'Connection' }
      },
      {
        path: 'payment-history',
        name: 'PaymentHistory',
        component: () => import('../views/PaymentHistory.vue'),
        meta: { title: '支付历史', icon: 'Money' }
      },
      {
        path: 'merchant-cooperation',
        name: 'MerchantCooperation',
        component: () => import('../views/MerchantCooperation.vue'),
        meta: { title: '商户合作', icon: 'Shop' }
      },
      {
        path: 'discover-management',
        name: 'DiscoverManagement',
        component: () => import('../views/DiscoverManagement.vue'),
        meta: { title: '发现管理', icon: 'Document' }
      },
      {
        path: 'service-channel-subscribers',
        name: 'ServiceChannelSubscribers',
        component: () => import('../views/ServiceChannelSubscribers.vue'),
        meta: { title: '服务号粉丝查询', icon: 'User' }
      },
      {
        path: 'template-messages',
        name: 'TemplateMessages',
        component: () => import('../views/TemplateMessages.vue'),
        meta: { title: '模板消息记录', icon: 'Message' }
      },
      {
        path: 'knowledge-base',
        name: 'KnowledgeBase',
        component: () => import('../views/KnowledgeBase.vue'),
        meta: { title: '知识库管理', icon: 'Document' }
      }
    ]
  }
]

// 使用 /fdxzs-admin 作为基础路径，避免与其他项目冲突
const router = createRouter({
  history: createWebHistory('/fdxzs-admin/'),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')
  
  // to.path 已经包含了 base 路径（/fdxzs-admin/），所以路径会是 /fdxzs-admin/login 或 /login
  const isLoginPage = to.path === '/fdxzs-admin/login' || to.path === '/login' || to.path.endsWith('/login')
  
  if (isLoginPage) {
    // 如果已登录，跳转到首页
    if (token) {
      next('/')
    } else {
      next()
    }
  } else {
    // 如果未登录，跳转到登录页
    if (!token) {
      next('/login')
    } else {
      next()
    }
  }
})

export default router

